import type { LineExportMessage } from './lineExportParser'
import type { LineInsightsResult } from './lineInsights'

export type LineImportPayload = {
  file_name: string
  source_hash: string
  messages: LineExportMessage[]
  analysis: Record<string, unknown>
  handoff_note: string | null
}

export type BuildLineImportPayloadInput = {
  fileName: string
  rawText: string
  messages: LineExportMessage[]
  analysis: Partial<LineInsightsResult> & Record<string, unknown>
}

export async function buildLineImportPayload(
  input: BuildLineImportPayloadInput
): Promise<LineImportPayload> {
  return {
    file_name: input.fileName.trim() || 'line-export.txt',
    source_hash: await sha256Hex(input.rawText),
    messages: input.messages,
    analysis: input.analysis,
    handoff_note:
      typeof input.analysis.handoffNote === 'string' && input.analysis.handoffNote.trim()
        ? input.analysis.handoffNote.trim()
        : null
  }
}

async function sha256Hex(text: string): Promise<string> {
  const bytes = new TextEncoder().encode(text)
  const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes)
  return [...new Uint8Array(digest)]
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}
